/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'GoalLinker.error.generic.description': '請檢查您的網際網路連線，然後再試一次。',
  'GoalLinker.error.generic.header': '發生錯誤',
  'GoalLinker.error.linking.header': '無法連結目標',
  'GoalLinker.error.max-entities-to-goal.description':
    '最多可以將 100 個{entities}連結至目標。如果您想要連結額外的{entities}，請移除一個{entity}。',
  'GoalLinker.error.max-entities-to-goal.header': '已達到 100 個{entity}的上限',
  'GoalLinker.error.max-goals.description': '最多可以連結 100 個目標。如果您想連結其他目標，請移除已連結的目標。',
  'GoalLinker.error.max-goals.header': '已達到 100 個目標的上限',
  'GoalLinker.goal-row.open-goal': '開啟目標',
  'GoalLinker.link-goals.error-description': '發生錯誤，請檢查您的網際網路連線並再試一次。',
  'GoalLinker.link-goals.error-title': '無法取消連結目標',
  'GoalLinker.linked-goals.header': '已連結目標',
  'GoalLinker.linked-goals.show-less': '顯示較少',
  'GoalLinker.linked-goals.show-more': '顯示其他 {count} 個',
  'GoalLinker.recents.emptystate-jira-product-discovery.description': '將構想與目標連結，以追蹤工作如何協助達成成果',
  'GoalLinker.recents.emptystate-project.description': '將您的專案與目標連結，以追蹤工作如何協助達成成果',
  'GoalLinker.recents.emptystate.description': '將您的工作項目與目標連結，以追蹤工作如何協助達成成果',
  'GoalLinker.recents.emptystate.header': '開始使用目標',
  'GoalLinker.recents.header': '最近的目標',
  'GoalLinker.search.emptystate.description': '請嘗試檢查是否有錯別字',
  'GoalLinker.search.emptystate.header': '沒有相符的結果',
  'GoalLinker.search.label': '結果',
  'GoalLinker.search.placeholder': '搜尋目標或貼上連結',
};
